module.exports = __webpack_public_path__ + "static/media/antigua-accommodation-16.12c3825e.jpg";